import React from 'react'
import { array } from 'prop-types'

const DataRow = ({ data, growerAndResellerSAP, resellerAndReceiverId }) => {

  const row = data.map((item, index) => {
    return (
      <React.Fragment key={`${item.value}-${index}`}>
        <div className='mb16 hide-tablet w25%'>
          <div className='tal fz13 c-darkgray fw600'>
            {item.title}
          </div>
          {
            item.title === 'Reseller' || item.title === 'Grain receiver' ? 
              <a
                className='c-blue-500 tal fz15 c-blue-700:h tdu:h'
                href={`/company/${item.title === 'Reseller' ? resellerAndReceiverId.resellerId : resellerAndReceiverId.receiverId}`}
              >
                {item.value}
              </a> : 
              <div className='tal fz15'>
                {item.value} 
              </div> 
          }
          {
            item.title === 'Reseller' && growerAndResellerSAP ? 
              <div className='c-darkgray fz13'>{growerAndResellerSAP.resellerSAPId}</div> : 
              item.title === 'Grower name' && growerAndResellerSAP ?
                <div className='c-darkgray fz13'>{growerAndResellerSAP.growerSAPId}</div> : null
          }
        </div>
        <div className='mb16 show-tablet w100%'>
          <div className='tac fz13 c-darkgray fw600'>
            {item.title}
          </div>
          <div className='tac fz15'>
            {item.value}
          </div> 
        </div>
      </React.Fragment>
    )
  })
  return(
    <div data-testid='dataRow'>
      <div className='df hide-tablet mt16' >
        {row}
      </div>
      <div className='show-tablet db'>
        {row}
      </div>
    </div>
  )
}

export default DataRow

DataRow.propTypes = {
  data: array.isRequired
}